import TableEmptyRow from 'components/others/TableEmptyRow';
import { useEmailsDirectory } from '../context/EmailsDirProvider';
import EmailsTableRow from './EmailsTableRow';

const EmailsTableBody = ({ others }: { others: boolean }) => {
    const { clientRows, otherRows } = useEmailsDirectory();
    const rows = others ? otherRows : clientRows;
    return <tbody>{rows.length ? rows.map((row) => <EmailsTableRow key={row.key} row={row} others={others} />) : <TableEmptyRow colSpan={others ? 5 : 3} />}</tbody>;
};

export default EmailsTableBody;
